import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';
import indigo from '@material-ui/core/colors/indigo';

import icons from 'img/services';
import {
  startRemoveWebsiteService,
} from 'store/actions/website';
import { ConfirmDialog } from 'components/admin/Dialogs';

const styles = theme => ({
  root:{
    margin: theme.spacing.unit*2,
    width: '350px',
    display: 'flex',
    flexDirection: 'column',
  },
  avatar: {
    color: '#fff',
    backgroundColor: indigo[300],
  },
  iconAvatar: {
    width: "140px",
    height: "140px",
    backgroundColor: indigo[300]
  },
  content: {
    paddingTop: theme.spacing.unit*3,
    backgroundColor: indigo[50],
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    }
  },
  description: {
    marginTop: theme.spacing.unit*3,
  },
  header: {
    '&:hover': {
      cursor: 'pointer',
    }
  },
});

class WebsiteServiceCard extends Component {
  constructor(props) {
    super(props);
    this.state = { showDelete: false };
  }

  handleCancel = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const { service, startRemoveWebsiteService } = this.props;
    startRemoveWebsiteService(service.id);
    this.setState({ showDelete: false });
  }

  render() {
    const {
      classes,
      service,
      handleDialog,
      startRemoveWebsiteService
    } = this.props;
    const { showDelete } = this.state;
    const icon = icons[service.icon] && icons[service.icon]["light-96"];

    return(
      <div>
        <ConfirmDialog
          open={showDelete}
          title="Delete Service"
          contentText="This action will delete the service. Proceed?"
          handleCancel={this.handleCancel}
          handleOk={this.handleDelete}
        />
        <Card
          className={classes.root}
        >
          <CardHeader
            className={classes.header}
            action={
              <FormControlLabel
                className={classes.show}
                control={
                  <Switch
                    disabled
                    color="primary"
                    checked={service.show}
                  />
                }
                label={service.show ? "show" : "hide"}
              />
            }
            avatar={
              <Avatar className={classes.avatar}>
                S
              </Avatar>
            }
            title={service.title}
            onClick={() => handleDialog(service)}
          />
          <CardContent
            className={classes.content}
            onClick={() => handleDialog(service)}
          >
            <Avatar className={classes.iconAvatar}>
              <img src={icon} />
            </Avatar>
            <Typography className={classes.description}>{service.description}</Typography>
          </CardContent>
          <CardActions>
            <Button onClick={() => this.setState({ showDelete: true })}>
              Delete
            </Button>
          </CardActions>
        </Card>
      </div>
    );
  }
}

const mapDispatchToProps = {
  startRemoveWebsiteService,
};

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps),
)(WebsiteServiceCard);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Services/WebsiteServiceCard.jsx